// All platform features that can be toggled per plan
// key: stored in DB features JSON, label: display name, category: grouping

export interface PlatformFeature {
  key: string;
  label: string;
  description: string;
  category: string;
}

export const PLATFORM_FEATURES: PlatformFeature[] = [
  // Cardápio
  { key: "menu_digital", label: "Cardápio Digital", description: "Cardápio online com QR Code", category: "Cardápio" },
  { key: "menu_customization", label: "Personalização do Menu", description: "Cores, fontes, layout e estilo dos cards", category: "Cardápio" },
  { key: "product_addons", label: "Adicionais de Produto", description: "Complementos e extras nos itens", category: "Cardápio" },
  { key: "product_images", label: "Imagens de Produtos", description: "Upload de fotos para os itens", category: "Cardápio" },
  { key: "ai_description", label: "Descrição com IA", description: "Geração automática de descrições", category: "Cardápio" },
  { key: "ai_image_generation", label: "Imagens com IA", description: "Geração de imagens de produtos por inteligência artificial", category: "Cardápio" },

  // Pedidos
  { key: "orders_dine_in", label: "Pedidos Mesa", description: "Pedidos via QR Code na mesa", category: "Pedidos" },
  { key: "orders_takeout", label: "Pedidos Takeout", description: "Pedidos para retirada", category: "Pedidos" },
  { key: "orders_delivery", label: "Pedidos Delivery", description: "Pedidos com entrega", category: "Pedidos" },
  { key: "orders_scheduled", label: "Pedidos Agendados", description: "Agendamento de pedidos futuros", category: "Pedidos" },
  { key: "kitchen_panel", label: "Painel da Cozinha", description: "Kanban em tempo real para produção", category: "Pedidos" },
  { key: "order_tracking", label: "Acompanhamento do Pedido", description: "Cliente acompanha status em tempo real", category: "Pedidos" },
  { key: "pdv", label: "PDV (Ponto de Venda)", description: "Terminal de venda para atendimento no balcão", category: "Pedidos" },

  // Mesas
  { key: "table_management", label: "Gestão de Mesas", description: "Comandas e controle de mesas ativas", category: "Mesas" },
  { key: "waiter_call", label: "Chamada de Garçom", description: "Cliente chama garçom pelo celular", category: "Mesas" },
  { key: "table_qrcode", label: "QR Code por Mesa", description: "Geração de QR Codes individuais", category: "Mesas" },
  { key: "waiter_module", label: "Módulo Garçom", description: "PDV móvel para garçons com gorjetas via PIX", category: "Mesas" },

  // Delivery
  { key: "delivery_management", label: "Gestão de Delivery", description: "Controle de entregadores e entregas", category: "Delivery" },
  { key: "delivery_tracking", label: "Rastreio de Entrega", description: "Acompanhamento da entrega pelo cliente", category: "Delivery" },

  // Pagamentos
  { key: "payment_pix", label: "Pagamento PIX", description: "Recebimento via PIX com QR Code", category: "Pagamentos" },
  { key: "payment_credit_card", label: "Cartão de Crédito", description: "Checkout transparente com cartão", category: "Pagamentos" },
  { key: "payment_mercadopago", label: "MercadoPago", description: "Integração com MercadoPago", category: "Pagamentos" },
  { key: "split_payment", label: "Dividir Conta", description: "Clientes podem dividir o pagamento entre pessoas", category: "Pagamentos" },

  // Fidelidade
  { key: "loyalty_program", label: "Programa de Fidelidade", description: "Pontos, carimbos ou cashback", category: "Fidelidade" },
  { key: "coupons", label: "Cupons de Desconto", description: "Criação e gestão de cupons", category: "Fidelidade" },
  { key: "customer_reactivation", label: "Reativação de Clientes", description: "Cupons automáticos para inativos", category: "Fidelidade" },

  // Gestão
  { key: "stock_management", label: "Controle de Estoque", description: "Gestão de ingredientes e estoque", category: "Gestão" },
  { key: "cost_reports", label: "Relatório de Custos", description: "Análise de custos por produto", category: "Gestão" },
  { key: "financial_management", label: "Gestão Financeira", description: "DRE, fluxo de caixa, contas a pagar/receber e despesas", category: "Gestão" },
  { key: "advanced_reports", label: "Relatórios Avançados", description: "Gráficos e análises detalhadas", category: "Gestão" },
  { key: "customer_management", label: "Gestão de Clientes", description: "Lista e histórico de clientes", category: "Gestão" },
  { key: "staff_management", label: "Gestão de Funcionários", description: "Cadastro de equipe, cargos, ponto e horas trabalhadas", category: "Gestão" },

  // Marketing
  { key: "promo_popups", label: "Popups Promocionais", description: "Banners e popups no cardápio", category: "Marketing" },
  { key: "social_links", label: "Redes Sociais", description: "Links para Instagram, Facebook, etc.", category: "Marketing" },
  { key: "marketing_ai", label: "Marketing com IA", description: "Legendas, calendário, Stories/Reels e geração de imagem com IA", category: "Marketing" },

  // Integrações
  { key: "ifood_integration", label: "Integração iFood", description: "Receba pedidos do iFood, sincronize cardápio e atualize status", category: "Integrações" },
  { key: "whatsapp_notifications", label: "WhatsApp Automático", description: "Notificações automáticas de pedidos e atendimento via WhatsApp", category: "Integrações" },
  { key: "instagram_shop", label: "Instagram Shop", description: "Sincronize catálogo com Instagram Shopping e venda pela rede social", category: "Integrações" },
  { key: "whatsapp_catalog", label: "Catálogo WhatsApp", description: "Sincronize produtos com o catálogo do WhatsApp Business", category: "Integrações" },

  // Suporte
  { key: "live_support", label: "Chat de Suporte", description: "Chat ao vivo com a plataforma", category: "Suporte" },
  { key: "order_ratings", label: "Avaliações de Pedidos", description: "Clientes avaliam comida e serviço", category: "Suporte" },

  // Inteligência
  { key: "growth_mode", label: "Modo Crescimento", description: "IA analisa seu restaurante e sugere promoções, combos, marketing e reativação", category: "Inteligência" },
];

// Group features by category
export const FEATURE_CATEGORIES = Array.from(
  new Set(PLATFORM_FEATURES.map(f => f.category))
);

// Check if a plan has a specific feature enabled
export const planHasFeature = (features: any, featureKey: string): boolean => {
  if (!features) return false;
  if (Array.isArray(features)) {
    // Legacy: string array — check if key exists
    return features.includes(featureKey);
  }
  if (typeof features === "object") {
    return features[featureKey] === true;
  }
  return false;
};

// Convert features (object or array) into human-readable label array
export const getFeatureLabels = (features: any): string[] => {
  if (!features) return [];
  if (Array.isArray(features)) {
    // Could be string labels already or key array
    return features.map((f) => {
      const found = PLATFORM_FEATURES.find((pf) => pf.key === f);
      return found ? found.label : String(f);
    });
  }
  if (typeof features === "object") {
    return Object.keys(features)
      .filter((key) => features[key] === true)
      .map((key) => {
        const found = PLATFORM_FEATURES.find((pf) => pf.key === key);
        return found ? found.label : key;
      });
  }
  return [];
};
